import { ChartStatusEnum } from '@generated';
import clsx from 'clsx';
import React from 'react';
import { Focusable, TooltipTrigger } from 'react-aria-components';
import { Tooltip } from '~/shared/components/Tooltip';

function getStatusColor(chartStatusId?: number) {
	if (!chartStatusId) {
		return 'bg-gray-400';
	} else if (chartStatusId === ChartStatusEnum.Admitted) {
		return 'bg-green-400';
	} else if (chartStatusId === ChartStatusEnum.PreAdmitted) {
		return 'bg-yellow-400';
	} else if (chartStatusId === ChartStatusEnum.Discharged) {
		return 'bg-gray-400';
	} else if (chartStatusId === ChartStatusEnum.Hospitalized) {
		return 'bg-orange-400';
	} else if (chartStatusId === ChartStatusEnum.OnHold) {
		return 'bg-yellow-400';
	} else if (chartStatusId === ChartStatusEnum.NTFC) {
		return 'bg-red-400';
	}
	return 'bg-gray-400';
}
export function PatientNameTableCell({
	firstName,
	lastName,
	patientIdentifier,
	chartStatusId
}: {
	firstName: string;
	lastName: string;
	patientIdentifier: string;
	chartStatusId?: number;
}) {
	const statusColorClass = getStatusColor(chartStatusId);
	const label = chartStatusId ? `Chart Status: ${ChartStatusEnum[chartStatusId]}` : 'Chart Status: Unknown';
	return (
		<div className="flex items-center gap-3">
			<div className="relative">
				<TooltipTrigger>
					<Focusable>
						<div role="button">
							<div className="flex size-10 items-center justify-center rounded bg-gray-100 text-sm font-medium text-gray-700">
								{firstName[0]}
								{lastName[0]}
							</div>

							<div className={clsx('absolute bottom-0 right-0 size-3 rounded-full border-2 border-white', statusColorClass)} />
						</div>
					</Focusable>
					<Tooltip>{label}</Tooltip>
				</TooltipTrigger>
			</div>
			<div className="flex flex-col">
				<div className="font-medium leading-tight text-gray-900">
					{lastName}, {firstName}
				</div>
				<div className="text-xs leading-tight text-gray-500">MR# {patientIdentifier}</div>
			</div>
		</div>
	);
}
